import { createAction } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { mergeMap, concat, of, delay } from "rxjs";
import { fetchBoostedOdds } from "@nxplatform/features/odds-booster/store/odds-booster.slice";
import { fetchAllCountries } from "@nxplatform/geo-data/slices/all-countries.slice";
import { fetchCurrencyVariables } from "@nxplatform/geo-data/slices/currency-variables.slice";
import { fetchCurrencies, fetchExchangeRates, fetchCryptoAlternative } from "@nxplatform/geo-data/slices/currency.slice";
import { fetchCustomerIpData } from "@nxplatform/geo-data/slices/ip-data.slice";
import { platformSettingsList } from "@nxplatform/platform-settings/platform-settings.slice";
import { fetchRegistrationConfigurations } from "@nxplatform/platform-settings/registration-settings.slice";
import { fetchSportConfig, fetchAlive, fetchOutcomesDescription, fetchMarketDescription, fetchStatusDescription, fetchGroupSorting } from "@nxplatform/sport/betradar-setup.slice";
import { fetchSport } from "@nxplatform/sport-list/types/sport.slice";
import { fetchProvinces } from "@nxplatform/store-shared/authentication/shared-authentication-actions";
import { getBetTournamentsData } from "@nxplatform/tournaments/bet-tournaments.slice";
import { BetTournamentsRequestField } from "@nxplatform/tournaments/client/bet-tournaments.client";
const setupAppInit = createAction("app/setupInit");
const setupAppInitEpic = (action$) => action$.pipe(
  ofType(setupAppInit.type),
  mergeMap(() => {
    const initialRequests = !window.newStructure ? [
      fetchCustomerIpData(),
      fetchAllCountries(),
      fetchCurrencies({
        orderField: "displayOrder",
        orderDirection: "DESC"
      })
    ] : [];
    const tournamentRequest = getBetTournamentsData({
      fields: [
        BetTournamentsRequestField.tournaments,
        BetTournamentsRequestField.leaderboards,
        BetTournamentsRequestField.authorizedUsers
      ]
    });
    const core = [
      platformSettingsList(),
      fetchSport(),
      fetchCurrencyVariables()
    ];
    const others = [
      fetchSportConfig(),
      fetchAlive(),
      fetchBoostedOdds(),
      fetchOutcomesDescription(),
      fetchMarketDescription(),
      fetchStatusDescription(),
      fetchGroupSorting(),
      fetchProvinces()
    ];
    const lowPriority = [
      fetchRegistrationConfigurations(),
      fetchExchangeRates(),
      fetchCryptoAlternative()
    ];
    return concat(
      of(...core),
      of(...initialRequests).pipe(delay(5)),
      of(tournamentRequest).pipe(delay(50)),
      of(...others).pipe(delay(100)),
      of(...lowPriority).pipe(delay(150))
    );
  })
);
export {
  setupAppInit,
  setupAppInitEpic
};
